<div class="flex flex-col gap-2 px-[8px]">
  <div class="filter-container rounded-2xl p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
    @if (loading()) {
      <div class="flex min-h-[300px] items-center justify-center">
        <app-loading />
      </div>
    } @else if (errorMessage()) {
      <app-error-data [title]="errorMessage()!" />
    } @else {
      @if (tableRows().length > 0) {
        <app-tables
          [headerItems]="headerItems()"
          [rows]="pagedRows()"
          [currentActions]="actions"
          (actionTrigger)="handleAction($event)" />
        <app-pagination
          [itemsPerPage]="itemsPerPage()"
          [currentPage]="currentPage()"
          [getPageNumbers]="getPageNumbers()"
          [totalPages]="totalPages()"
          [startItem]="startItem()"
          [endItem]="endItem()"
          [totalItems]="totalItems()"
          (previousPage)="onPreviousPage()"
          (nextPage)="onNextPage()"
          (goToPage)="onGoToPage($event)"
          (changePageNumber)="onChangePageNumber($event)"
          (pageSizeChange)="onPageSizeChange()" />
      } @else {
        <div class="flex flex-col items-center justify-center py-12 text-center">
          <h3 class="text-lg font-semibold text-gray-700">
            <span i18n="@@bankAccountsNoAccounts">No bank accounts found</span>
          </h3>
        </div>
      }
    }
    @if (successMessage()) {
      <app-successful-notification type="success" [title]="successMessage()!" />
    }
    @if (showDeleteDialog()) {
      <app-confirmation-dialog
        [layout]="'start'"
        [title]="deleteTitle"
        [description]="deleteDescription"
        [confirmContent]="confirmButton"
        [cancelContent]="cancelButton"
        (onCancel)="onCancelDelete()"
        (onSubmit)="onConfirmDelete()"
        [error]="deleteErrorMessage()" />
    }
  </div>
</div>
